import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Dialog, DialogTitle } from '@material-ui/core';
import { Button, Select } from '@ipc/ipc-components';
import React, { useEffect, useState } from 'react';
import { getAllHandlers } from '../../../handlers/redux/selectors/HandlersSelectors';
import { getAllHandlersRequestActionCreator } from '../../../handlers/redux/actions/HandlersActions';
import { AddHandlerDialogStyle } from '../component/AddHandlerDialog.styles';

function AddHandlerDialog(props) {
  const {
    openDialog,
    closeDialog,
    allHandlers,
    fetchAllHandlers,
    onSubmit,
  } = props;

  const [selectedHandlers, setSelectedHandlers] = useState([]);

  const handlerOptions = allHandlers.map((handler) => ({
    label: handler.handlerName,
    value: handler.handlerId,
  }));

  const handleOnClose = () => {
    setSelectedHandlers([]);
    closeDialog();
  };

  const handleOnChange = (selectedValue) => {
    setSelectedHandlers(selectedValue);
  };

  const confirmSave = () => {
    onSubmit(selectedHandlers);
    handleOnClose();
  };

  useEffect(() => {
    if (openDialog) fetchAllHandlers();
  }, [openDialog]);

  return (
    <Dialog onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <AddHandlerDialogStyle>
        <DialogTitle id="simple-dialog-title">Add Handler to Handler Association form</DialogTitle>
        <div className="associate-handler-add-handler-body">
          <div className="form-input-fields">
            <Select
              options={handlerOptions}
              onChange={handleOnChange}
              isMulti
            />
          </div>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleOnClose} id="cancel">Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${selectedHandlers === null || selectedHandlers.length === 0} after-box-submit`}
            disabled={selectedHandlers === null || selectedHandlers.length === 0}
            id="submit"
          >
            Submit
          </Button>
        </div>
      </AddHandlerDialogStyle>
    </Dialog>
  );
}

AddHandlerDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  allHandlers: PropTypes.arrayOf(PropTypes.object),
  fetchAllHandlers: PropTypes.func,
  onSubmit: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    allHandlers: getAllHandlers(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchAllHandlers: getAllHandlersRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddHandlerDialog);
